import { PcodeRenderData } from './pcode';

export enum PreviewPopupVisibleType {
    bannerPreview = 'BannerPreview',
    bannerCreativePreview = 'BannerCreativePreview'
}

export interface BannerCreativePreviewPopupState {
    previewPopupVisibleType?: PreviewPopupVisibleType;
    creativeUrl?: string;
    pcodeRenderData?: PcodeRenderData;
    id?: string;
}
